import { render } from "./productPackageList.vue?vue&type=template&id=65950dcf&scoped=true"
import script from "./productPackageList.vue?vue&type=script&lang=js"
export * from "./productPackageList.vue?vue&type=script&lang=js"

import "./productPackageList.vue?vue&type=style&index=0&id=65950dcf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65950dcf"],['__file',"src/views/product/productPackageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65950dcf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65950dcf', __exports__)) {
    api.reload('65950dcf', __exports__)
  }
  
  module.hot.accept("./productPackageList.vue?vue&type=template&id=65950dcf&scoped=true", () => {
    api.rerender('65950dcf', render)
  })

}


export default __exports__